import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_NPDAY_70: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_NPDAY_70,
  },
  {
    pageId: PageId.CHAT_UPSELL_NPDAY_70,
  },
  {
    pageId: PageId.UPSELL_NPDAY_70,
  },
  {
    pageId: PageId.DOWNLOAD_NPDAY_70,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
